(() => {
  const ShopifyRoot =
    window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

  let lastKnownCount = null;

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getCartCountFromDOM() {
    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (cartIcon) {
      const bubble = cartIcon.querySelector('.cart-count-bubble');

      // In Dawn-style themes, no bubble means cart is empty.
      if (!bubble) return 0;

      const visibleCount =
        bubble.querySelector('span[aria-hidden="true"]') ||
        bubble.querySelector('span');

      if (visibleCount) {
        const count = parseInt(
          visibleCount.textContent.replace(/\D/g, ''),
          10
        );

        if (!Number.isNaN(count)) return count;
      }
    }

    const otherCounter = document.querySelector(
      '[data-cart-count], .cart-count'
    );

    if (otherCounter) {
      const count = parseInt(
        otherCounter.textContent.replace(/\D/g, ''),
        10
      );

      if (!Number.isNaN(count)) return count;
    }

    return lastKnownCount;
  }

  async function getCart() {
    const response = await fetch(`${ShopifyRoot}cart.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Could not read cart');
    }

    return response.json();
  }

  function getButtonLabel(button) {
    if (!button) return null;

    if (button.tagName === 'INPUT') {
      return button;
    }

    return (
      button.querySelector('[data-add-to-cart-text]') ||
      button.querySelector('.button__text') ||
      button.querySelector('span')
    );
  }

  function getLabelText(label) {
    if (!label) return '';

    return label.tagName === 'INPUT'
      ? label.value
      : label.textContent.trim();
  }

  function setLabelText(label, text) {
    if (!label) return;

    if (label.tagName === 'INPUT') {
      label.value = text;
    } else {
      label.textContent = text;
    }
  }

  function bumpCartIcon() {
    const icon =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.header__icon--cart');

    if (!icon) return;

    icon.classList.remove('doaba-cart-bump');

    // Restart animation.
    void icon.offsetWidth;

    icon.classList.add('doaba-cart-bump');

    setTimeout(() => {
      icon.classList.remove('doaba-cart-bump');
    }, 500);
  }

  function showAdded(button, label, originalText) {
    if (!button || !button.isConnected) return;

    button.dataset.doabaState = 'added';

    setLabelText(label, '✓ Added to bag');

    bumpCartIcon();

    setTimeout(() => {
      if (!button.isConnected) return;

      button.dataset.doabaState = '';

      setLabelText(label, originalText || 'Add to cart');
    }, 1400);
  }

  function restoreButton(button, label, originalText) {
    if (!button || !button.isConnected) return;

    button.dataset.doabaState = '';

    setLabelText(label, originalText || 'Add to cart');
  }

  async function confirmCartIncrease(
    beforeCount,
    button,
    label,
    originalText
  ) {
    // Give the theme's own AJAX request a moment to start.
    await delay(200);

    for (let attempt = 0; attempt < 12; attempt++) {
      try {
        const cart = await getCart();

        const currentCount = Number(cart.item_count || 0);

        if (
          beforeCount !== null &&
          currentCount > beforeCount
        ) {
          lastKnownCount = currentCount;

          showAdded(
            button,
            label,
            originalText
          );

          return;
        }

        lastKnownCount = currentCount;
      } catch (error) {
        // Do nothing. The theme still controls the actual cart request.
      }

      await delay(200);
    }

    // Don't claim success if Shopify didn't confirm it.
    restoreButton(
      button,
      label,
      originalText
    );
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form =
        event.target.closest &&
        event.target.closest(
          'form[action*="/cart/add"]'
        );

      if (!form) return;

      const button =
        event.submitter ||
        form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );

      if (!button || button.disabled) return;

      const label = getButtonLabel(button);

      if (!label) return;

      const originalText = getLabelText(label);

      // Ignore unavailable/sold-out buttons.
      if (
        /sold out|unavailable/i.test(originalText)
      ) {
        return;
      }

      let beforeCount = getCartCountFromDOM();

      if (beforeCount === null) {
        beforeCount =
          lastKnownCount !== null
            ? lastKnownCount
            : 0;
      }

      button.dataset.doabaState = 'adding';

      setLabelText(label, 'Adding…');

      confirmCartIncrease(
        beforeCount,
        button,
        label,
        originalText
      );
    },
    true
  );

  // Establish initial cart count.
  getCart()
    .then((cart) => {
      lastKnownCount = Number(
        cart.item_count || 0
      );
    })
    .catch(() => {
      // Non-critical enhancement.
    });
})();
/* =========================================
   DOABA — MOBILE STICKY ADD TO CART
   ========================================= */

(() => {

  const stickyBar =
    document.querySelector('[data-doaba-sticky-atc]');

  if (!stickyBar) return;


  const stickyButton =
    stickyBar.querySelector(
      '[data-doaba-sticky-button]'
    );

  const stickyLabel =
    stickyBar.querySelector(
      '[data-doaba-sticky-label]'
    );

  const stickyPrice =
    stickyBar.querySelector(
      '[data-doaba-sticky-price]'
    );


  /* -----------------------------------------
     FIND THE REAL PRODUCT FORM
     ----------------------------------------- */

  function getProductForm() {

    /*
      Prefer the main product area so we don't
      accidentally target recommended products.
    */

    const mainProduct =
      document.querySelector(
        'main product-info, main .product, main [data-section-type="product"]'
      );

    if (mainProduct) {

      const form =
        mainProduct.querySelector(
          'form[action*="/cart/add"]'
        );

      if (form) return form;
    }


    /*
      Fallback for custom Shopify themes
    */

    return document.querySelector(
      'main form[action*="/cart/add"]'
    );

  }


  function getMainButton() {

    const form = getProductForm();

    if (!form) return null;


    return (
      form.querySelector(
        'button[name="add"]'
      ) ||

      form.querySelector(
        'button[type="submit"]'
      ) ||

      form.querySelector(
        'input[type="submit"]'
      )
    );

  }


  /* -----------------------------------------
     FIND CURRENT PRODUCT PRICE
     ----------------------------------------- */

  function getCurrentPrice() {

    const main =
      document.querySelector('main');

    if (!main) return null;


    /*
      Dawn / modern Shopify sale price
    */

    const priceCandidates = [

      '.product__info-container .price__sale .price-item--sale',

      '.product__info-wrapper .price__sale .price-item--sale',

      '.product__info-container .price__regular .price-item--regular',

      '.product__info-wrapper .price__regular .price-item--regular',

      '[id^="price-"] .price-item--sale',

      '[id^="price-"] .price-item--regular',

      '[data-product-price]'

    ];


    for (
      const selector of priceCandidates
    ) {

      const elements =
        main.querySelectorAll(selector);


      for (const element of elements) {

        /*
          offsetParent helps prevent us from
          grabbing a hidden regular/sale price.
        */

        if (
          element.offsetParent !== null
        ) {

          const text =
            element.textContent
              .replace(/\s+/g, ' ')
              .trim();


          if (text) {
            return text;
          }

        }

      }

    }


    return null;

  }


  /* -----------------------------------------
     BUTTON TEXT
     ----------------------------------------- */

  function getButtonText(button) {

    if (!button) return 'Add to cart';


    if (
      button.tagName === 'INPUT'
    ) {

      return button.value.trim();

    }


    const textElement =

      button.querySelector(
        '[data-add-to-cart-text]'
      ) ||

      button.querySelector(
        '.button__text'
      ) ||

      button.querySelector('span');


    return (
      textElement
        ? textElement.textContent
        : button.textContent
    )
      .replace(/\s+/g, ' ')
      .trim();

  }


  /* -----------------------------------------
     SYNC STICKY BAR
     ----------------------------------------- */

  function syncStickyBar() {

    const mainButton =
      getMainButton();


    if (!mainButton) {

      stickyBar.classList.remove(
        'is-visible'
      );

      return;

    }


    /* Price */

    const currentPrice =
      getCurrentPrice();


    if (
      currentPrice &&
      stickyPrice
    ) {

      stickyPrice.textContent =
        currentPrice;

    }


    /* Availability */

    const buttonText =
      getButtonText(mainButton);


    const unavailable =

      mainButton.disabled ||

      mainButton.getAttribute(
        'aria-disabled'
      ) === 'true' ||

      /sold out|unavailable/i.test(
        buttonText
      );


    stickyButton.disabled =
      unavailable;


    if (stickyLabel) {

      if (unavailable) {

        stickyLabel.textContent =
          'Sold out';

      }

      else if (
        /adding/i.test(buttonText)
      ) {

        stickyLabel.textContent =
          'Adding…';

      }

      else if (
        /added/i.test(buttonText)
      ) {

        stickyLabel.textContent =
          '✓ Added to bag';

      }

      else {

        stickyLabel.textContent =
          'Add to cart';

      }

    }

  }


  /* -----------------------------------------
     SHOW ONLY AFTER ORIGINAL BUTTON
     HAS SCROLLED ABOVE THE SCREEN
     ----------------------------------------- */

  let ticking = false;


  function updateVisibility() {

    ticking = false;


    /*
      Desktop should never show it.
    */

    if (
      window.innerWidth > 749
    ) {

      stickyBar.classList.remove(
        'is-visible'
      );

      stickyBar.setAttribute(
        'aria-hidden',
        'true'
      );

      return;

    }


    const mainButton =
      getMainButton();


    if (!mainButton) return;


    const rect =
      mainButton.getBoundingClientRect();


    /*
      Important:

      We only show it when the original
      Add to Cart button has passed ABOVE
      the viewport.

      This prevents the sticky button from
      appearing immediately when the real
      button is still further down the page.
    */

    const shouldShow =
      rect.bottom < 0;


    stickyBar.classList.toggle(
      'is-visible',
      shouldShow
    );


    stickyBar.setAttribute(
      'aria-hidden',
      shouldShow
        ? 'false'
        : 'true'
    );

  }


  function requestVisibilityUpdate() {

    if (ticking) return;


    ticking = true;


    requestAnimationFrame(
      updateVisibility
    );

  }


  /* -----------------------------------------
     CLICK STICKY BUTTON
     ----------------------------------------- */

  stickyButton.addEventListener(
    'click',
    () => {

      const mainButton =
        getMainButton();


      if (
        !mainButton ||
        mainButton.disabled
      ) {

        return;

      }


      /*
        Give instant feedback.
      */

      if (stickyLabel) {

        stickyLabel.textContent =
          'Adding…';

      }


      /*
        Trigger Shopify's REAL button.

        Your existing theme handles:
        - variant
        - quantity
        - Ajax cart
        - cart drawer
        - errors
      */

      mainButton.click();


      /*
        Theme / previous Doaba script will
        update the original button.
        Mirror that state shortly afterwards.
      */

      setTimeout(
        syncStickyBar,
        50
      );

      setTimeout(
        syncStickyBar,
        400
      );

      setTimeout(
        syncStickyBar,
        1500
      );

    }
  );


  /* -----------------------------------------
     WATCH PRODUCT CHANGES
     ----------------------------------------- */

  const productArea =
    document.querySelector(
      'main product-info, main .product'
    );


  if (
    productArea &&
    'MutationObserver' in window
  ) {

    const observer =
      new MutationObserver(() => {

        syncStickyBar();

        requestVisibilityUpdate();

      });


    observer.observe(
      productArea,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'disabled',
          'aria-disabled',
          'class'
        ]
      }
    );

  }


  /*
    Variant dropdown / radio changes
  */

  document.addEventListener(
    'change',
    (event) => {

      if (
        !event.target.closest(
          'main'
        )
      ) {

        return;

      }


      setTimeout(
        syncStickyBar,
        50
      );

      setTimeout(
        syncStickyBar,
        300
      );

    }
  );


  /* -----------------------------------------
     SCROLL + RESIZE
     ----------------------------------------- */

  window.addEventListener(
    'scroll',
    requestVisibilityUpdate,
    {
      passive: true
    }
  );


  window.addEventListener(
    'resize',
    requestVisibilityUpdate
  );


  /* -----------------------------------------
     INITIALISE
     ----------------------------------------- */

  syncStickyBar();

  updateVisibility();

})();